"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const actions_1 = require("../app/actions/actions");
const INIT_STATE = {
    saveCSVDataS21: [],
    saveCSVDataS24: [],
};
exports.default = (state = INIT_STATE, action) => {
    switch (action.type) {
        case actions_1.SAVE_CSV_DATAS21: {
            return Object.assign({}, state, { saveCSVDataS21: action.payload });
        }
        case actions_1.SAVE_CSV_DATAS24: {
            return Object.assign({}, state, { saveCSVDataS24: action.payload });
        }
        default:
            return state;
    }
};
//# sourceMappingURL=csv-data.js.map